export default __webpack_public_path__ + "static/media/guitar_1.394602dd.png";